export default function findLigneWithMasqueLigne(lignesCommandes) {
  return lignesCommandes.some((ligne) => {
    return ligne.lignesCommande && ligne.lignesCommande.find((ligneEnfant) => {
      return ligneEnfant.masqueLigne;
    });
  });
}
